function parseTaggedFields(raw) {
  const fields = {}
  if (!raw || typeof raw !== 'string') {
    return fields
  }
  const pipeIdx = raw.indexOf(' | ')
  const tagSource = pipeIdx >= 0 ? raw.slice(pipeIdx + 3) : raw
  const pattern = /(\w+)=([^\s]+)/g
  let match = pattern.exec(tagSource)
  while (match != null) {
    fields[match[1]] = match[2]
    match = pattern.exec(tagSource)
  }
  return fields
}

function stripTechnicalSuffix(raw) {
  const trimmed = (raw || '').trim()
  const pipeIdx = trimmed.indexOf(' | ')
  if (pipeIdx > 0) {
    return trimmed.slice(0, pipeIdx).trim()
  }
  return trimmed
}

export function isHeartbeatTelemetryEvent(ev) {
  const type = (ev.eventType ?? ev.EventType ?? '').trim().toLowerCase()
  const code = (ev.eventCode ?? ev.EventCode ?? '').trim()
  return type === 'heartbeat' || code === 'ELECTRON_MAIN_HEARTBEAT'
}

export function formatHeartbeatOperationalMessage(ev) {
  const raw = (ev.message ?? ev.Message ?? '').trim()
  const summary = stripTechnicalSuffix(raw)
  if (summary && !summary.startsWith('Electron heartbeat')) {
    return summary
  }

  const fields = parseTaggedFields(raw)
  const windowPart =
    fields.window === 'visible'
      ? 'The desktop app is running with the dashboard window visible.'
      : 'The desktop app is running in the background (tray).'
  const dashboardPart =
    fields.dashboardLoginActive === 'true'
      ? 'Dashboard sign-in is active.'
      : 'Dashboard sign-in is not active.'
  let pepPart = 'Hilton PEP sign-in status is unknown.'
  if (fields.pepBearerPresent === 'false') {
    pepPart = 'No Hilton PEP sign-in token is stored on this device.'
  } else if (fields.pepLoginActive === 'true') {
    pepPart = 'Hilton PEP sign-in is verified and can pull data.'
  } else if (fields.pepAuthFailureRecent === 'true') {
    pepPart =
      'Hilton PEP rejected the stored token recently; recovery or manual sign-in is required.'
  } else if (
    fields.pepKeepAliveProof === 'false' &&
    fields.pepDataPullProof === 'false'
  ) {
    pepPart =
      'A Hilton PEP token is stored but has not been verified recently; data pulls may fail until sign-in is refreshed.'
  } else if (fields.pepLoginActive === 'false') {
    pepPart = 'Hilton PEP sign-in is not verified on this device.'
  }

  if (summary.startsWith('Electron heartbeat')) {
    return `${windowPart} ${dashboardPart} ${pepPart}`
  }

  return summary || `${windowPart} ${dashboardPart} ${pepPart}`
}

export function heartbeatEventShortLabel() {
  return 'Desktop status heartbeat'
}

export { parseTaggedFields as parseHeartbeatTaggedFields }
